"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.DefaultClientSettings = void 0;
const logger_1 = require("../logger");
const FIELD_KEY = '__hls#client-settings';
const wnd = typeof window === 'undefined' ? global : window;
exports.DefaultClientSettings = (wnd[FIELD_KEY] = (_a = wnd[FIELD_KEY]) !== null && _a !== void 0 ? _a : {
    url: '',
    logger: new logger_1.NullLogger(),
    getHeaders: () => ({}),
    onRequest: () => ({}),
    onResponse: () => ({}),
});
//# sourceMappingURL=default-client.settings.js.map